import { ParentDomain } from "./common";
export const EnvironmentBasedAppDomain = {
    development: "https://app-dev.refactor.academy",
    staging: "https://app-staging.refactor.academy",
    production: "https://app.refactor.academy"
};
export const EnvironmentBasedWizardDomain = {
    development: "https://wizard-dev.refactor.academy",
    staging: "https://wizard-staging.refactor.academy",
    production: "https://wizard.refactor.academy"
};
export const EnvironmentBasedAdminDomain = {
    development: "https://admin-dev.refactor.academy",
    staging: "https://admin-staging.refactor.academy",
    production: "https://admin.refactor.academy"
};
export const EnvironmentBasedCoderPrepDomain = {
    development: "https://coderprep-dev.refactor.academy",
    staging: "https://coderprep-staging.refactor.academy",
    production: "https://coderprep.refactor.academy"
};
export const EnvironmentBasedInterviewPrepDomain = {
    development: "https://interviewprep-dev.refactor.academy",
    staging: "https://interviewprep-staging.refactor.academy",
    production: "https://interviewprep.refactor.academy"
};
export const EnvironmentBasedInventoryDomain = {
    development: "https://inventory-dev.refactor.academy/",
    staging: "https://inventory-staging.refactor.academy/",
    production: "https://inventory.refactor.academy/"
};
export const EnvironmentBasedBootcampDomain = {
    development: "https://bootcamp-dev.refactor.academy",
    staging: "https://bootcamp-staging.refactor.academy",
    production: "https://bootcamp.refactor.academy"
};
export const LocalHostDomain = {
    local: (portNumber) => `http://localhost:${portNumber}`,
};
export const EnvironmentBasedCommonDomain = {
    development: (subdomain, domain = ParentDomain) => `https://${subdomain}-dev.${domain}`,
    staging: (subdomain, domain = ParentDomain) => `https://${subdomain}-staging.${domain}`,
    production: (subdomain, domain = ParentDomain) => `https://${subdomain}.${domain}`,
};
